<div class="bg-white rounded-xl p-4 shadow-md">
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-2">
      <img src="../../../../assets/folder.png" alt="Folder Icon" class="w-6 h-6" />
      <h2 class="text-sm font-semibold truncate">{{ folderName }}</h2>
    </div>
    <button type="button" (click)="toggleFolder()">
      <app-icon-chevron-down [ngClass]="{ 'rotate-180': isOpen }"></app-icon-chevron-down>
    </button>
  </div>
  <p class="text-xs text-gray-500 mt-1">{{ filePaths?.length }} {{'BATCH_LINE.FILES' | translate}}</p>
  @if (isOpen) {
  <div class="mt-3 border-t pt-2">
    @for (file of filePaths; track file) {
    <div class="w-full py-1">
      <app-display-file [filename]="file" [splitted]="true" class="block w-full"></app-display-file>
    </div>
    }
  </div>
  }
</div>